export enum EProjectAuthType {
  none = 0,
  genericAuth = 1,
  oAuth2 = 2,
  ldap = 3,
  msal = 4
}
